export default __webpack_public_path__ + "static/media/visitRailwayStation.404cff68.jpg";